'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    mui = require('material-ui'),
    {RaisedButton} = mui,
    {Navigation} = require('react-router');

const Page404 = React.createClass({displayName: "Page404",

    mixins: [Navigation],

    handleSubmit() {
        this.transitionTo('/dashboard');
    },

    render: function () {
        return (
            React.createElement("div", {className: "text-center jumbotron", 
                 style:  {
                     paddingTop: '5%',
                     backgroundColor: '#fff'
                 } }, 
                React.createElement("h1", null, t('page404_message_error_404')), 
                React.createElement("h3", null, t('page404_message_error_beer_not_found')), 
                React.createElement("br", null), 
                React.createElement(RaisedButton, {label: t('page404_label_go_to_dashboard'), secondary: true, onClick: this.handleSubmit})
            )
        );
    }
});

module.exports = Page404;





/** WEBPACK FOOTER **
 ** ./src/views/Page404/Page404.jsx
 **/